var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('font-awesome-icon',{staticClass:"cocktail-icon",attrs:{"icon":"cocktail"}})],1),_c('h1',[_vm._v("Cocktail Recipe Finder")])])}
var staticRenderFns = []

export { render, staticRenderFns }